import { observer } from 'mobx-react-lite'

import { StatusTag } from '@/Ship/Components/StatusTag'

import { CLIENT_FIELD_LABELS } from '../Contracts/ClientFieldLabels'

import type { ClientFormContextLike } from '../Contracts/IClient'

/**
 * «Статус» у блоці «Загальне» — лише перегляд (`SPEC-009` §8.3): статус
 * ставлять створення («Новий») і переходи верифікації, а не форма.
 *
 * Малюється бейджем кольору довідника, тим самим `StatusTag`, що в колонці
 * реєстру й у шапці. Ядровий `StatusInput` тут не годиться: він шукає статус
 * серед `options` ресурсу, а в клієнта статус — рядок довідника.
 *
 * Розмітка — та сама, що в Ship-шаблонів поля (`BaseViewFieldTemplate` /
 * `BaseFieldTemplate`): підпис стоїть там само, де в сусідніх полів, і e2e
 * знаходить поле за підписом тим самим локатором (`helpers/ui.formField`).
 */
export const ClientStatusCell = observer(({ formContext }: { formContext: ClientFormContextLike }) => {
    const status = formContext.values?.status
    const label = CLIENT_FIELD_LABELS.status
    const tag =
        status && typeof status.title === 'string' ? (
            <StatusTag label={status.title} color={status.color} />
        ) : (
            '—'
        )

    if (formContext.isEditable !== true) {
        return (
            <div className="form-field-view">
                <div className="field-view-label">{label}</div>
                <div className="field-view-value">{tag}</div>
            </div>
        )
    }

    return (
        <div className="form-field form-field-default">
            <label className="field-label">
                <h2 className="field-label-title">{label}</h2>
            </label>
            <div>{tag}</div>
        </div>
    )
})
